<template>
  <div id="app">
    <!-- <v-sidebar v-if="$route.meta.sideBarKeepAlive"></v-sidebar> -->
    <router-view/>
  </div>
</template>

<script>
import SideBar from "./components/Public/SideBar";

export default {
  name: 'App',
  components: {
    'v-sidebar': SideBar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue